import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { TdsMerchantDetail } from '@root/globalTypes';

export function useGetTdsMerchant({ id }: { id: string }) {
  const { query } = useApi();

  const { data, isPending } = useQuery<{ tdsMerchant: TdsMerchantDetail }>({
    queryKey: [...queryKeys.tdsMerchants, id],
    queryFn: (): Promise<{ tdsMerchant: TdsMerchantDetail }> =>
      query({ path: `v1/staff/tds_merchants/${id}` }),
  });

  return {
    data: data?.tdsMerchant,
    isPending,
  };
}
